module.exports = __webpack_public_path__ + "static/media/END CAP PLAIN END ( 592-00379 ) FOR SDS 900-1200 MACHINES..bce307c3.jpg";